import React, { useContext, useEffect, useState } from "react";

// Formik validation
import * as Yup from "yup";
import { useFormik as useFormic } from "formik";

// Image
import garmenzoLogo from "assets/images/logo-dark.png";
import arolisaLogo from "assets/images/Plentima-Logo.png";
import withRouter from "Common/withRouter";
import AuthIcon from "pages/AuthenticationInner/AuthIcon";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { addMenu, addPermissions, addRoleMenu, getMenus, getMenusByRole, getResources, getUserPermissions, postLogin } from "helpers/backend_helper";
import { AppContext } from "context/AppContext";

import { Common } from "helpers/common";
import { menuData } from "Layout/LayoutMenuData";
import { appName } from "constants/constants";

const Login = (props: any) => {

    document.title = "Login | " + appName;

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [success, setSuccess] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const { setPermissions, setMenus, setUserName, setIsSystemAdmin, setUser } = useContext(AppContext);
    const [logo, setLogo] = useState<any>(appName === "Plentima" ? arolisaLogo : garmenzoLogo);

    useEffect(() => {
        console.log('logo', logo)
        console.log('appName', appName)

        // setLogo(process.env.REACT_APP_LOGO??'assets/images/logo-dark.png');
    }, []);


    const validation: any = useFormic({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: async (values: any) => {
            setIsLoading(true);

            try {
                let response: any;
                let loginSuccess = false;
                try {
                    const data = {
                        email: values.email,
                        password: values.password
                    }

                    response = await postLogin(data);
                    console.log(response);
                    loginSuccess = true;
                }
                catch (e) {
                    setError('Error');
                    console.log(e);
                    setIsLoading(false);
                }

                if (loginSuccess) {
                    localStorage.setItem("app-permissions", "[]");

                    // Store tokens
                    const authToken = response.data.authToken.replace('Bearer ', '');
                    const refreshToken = response.data.refreshToken.replace('Bearer ', '');
                    localStorage.setItem("token", authToken);
                    localStorage.setItem("refreshToken", refreshToken);

                    // Store user data
                    localStorage.setItem("user", JSON.stringify(response.data));
                    // localStorage.setItem("userId", response.data.userId.toString());
                    // localStorage.setItem("businessId", response.data.businessId?.toString() || '');
                    // localStorage.setItem("userRoleId", response.data.userRoleId.toString());
                    // localStorage.setItem("fullName", response.data.fullName);
                    // localStorage.setItem("email", response.data.email);
                    // localStorage.setItem("documentStatus", response.data.documentStatus);
                    // localStorage.setItem("isActive", response.data.isActive.toString());
                    // localStorage.setItem("isPhoneVerified", response.data.isPhoneVerified.toString());
                    // localStorage.setItem("isEmailVerified", response.data.isEmailVerified.toString());

                    const roleId = response?.data?.userRoleId ?? 0;
                    const common = new Common();

                    if (response) {
                        const appRole = response.data.userRole;
                        localStorage.setItem("IDKS@ROLE", common.encrypt(appRole));
                        localStorage.setItem("user-name", response.data.fullName);
                        
                        // Set user data in context
                        const userData = {
                            authToken,
                            refreshToken,
                            userId: response.data.userId,
                            businessId: response.data.businessId,
                            userRoleId: response.data.userRoleId,
                            userRole: response.data.userRole,
                            fullName: response.data.fullName,
                            email: response.data.email,
                            documentStatus: response.data.documentStatus,
                            isActive: response.data.isActive,
                            isPhoneVerified: response.data.isPhoneVerified,
                            isEmailVerified: response.data.isEmailVerified
                        };
                        setUser(userData);
                        
                        // Set other context values
                        setUserName(response.data.fullName);
                        const appIsSystemAdmin = ((appRole === "system-admin") || (appRole === "system-admin")) ? true : false;
                        setIsSystemAdmin(appIsSystemAdmin);

                        try {
                            const responsePermission = await getUserPermissions(response.data.userRole);
                            localStorage.setItem("app-permissions", JSON.stringify(responsePermission.data || []));
                            setPermissions(responsePermission.data || []);
                        } catch (error) {
                            localStorage.setItem("app-permissions", JSON.stringify([]));
                            setPermissions([]);
                        }

                        try {
                            const responseMenu = await getMenusByRole(roleId);
                            localStorage.setItem("app-menus", JSON.stringify(responseMenu.data || []));
                            setMenus(responseMenu.data || []);
                        } catch (error) {
                            localStorage.setItem("app-menus", JSON.stringify([]));
                            setMenus([]);
                        }

                        setTimeout(() => {
                            setIsLoading(false);
                            props.router.navigate("/dashboard");
                            return false;
                        }, 1000)
                    }
                }

                return false;
            }
            catch (error) {
                console.log(error);
                setError('Error');
                return false;
            }
        }
    });



    const buildRoleMenu = async () => {
        const response = await getMenus();
        console.log('Menu Response', response.data);


        //  const p =
        // {
        //     "roleId": 2,
        //     "menuId": 10,
        //     "isActive": true
        // };

        // console.log('P - ', p);

        // const res = await addRoleMenu(p);

        response.data.forEach(async (item: any, index: number) => {

            const p =
            {
                "roleId": 2,
                "menuId": item.id,
                "isActive": true
            };

            console.log('P - ', p);
            if (item.id != 10 && item.id != 37 && item.id != 38 || item.id != 39) {
                const res = await addRoleMenu(p);
            }

        });


        // {
        //     "roleId" : 18,
        //     "menuId" : 2,
        //     "isActive" :  true
        // }

    }

    const buildMenu = () => {

        menuData.forEach(async (item: any, index: number) => {

            const p = {
                "name": item.label,
                "url": item.link,
                "icon": item.label + ".jpg",
                "isActive": true
            }
            console.log('P - ', p);

            try {


                const resMenu = await addMenu(p);

                console.log('P - ', resMenu);

                if (item?.subItems?.length > 0) {
                    item?.subItems.forEach(async (itemC: any, index: number) => {
                        const c = {
                            "name": itemC.label,
                            "url": itemC.link,
                            "parentId": resMenu.data.id,
                            "icon": itemC.label + ".jpg",
                            "isActive": true
                        }
                        console.log('C - ', c);
                        const resMenuC = await addMenu(c);
                        console.log('P - ', resMenuC);

                        //console.log('C - ' + itemC.label);
                    })
                }
            } catch (error) {
                console.log('P - ', error);
            }

        })

        // const response2 = await getResources();
        // response2.data.forEach(async (item: any, index: number) => {
        //       await addPermissions({
        //         role: "admin",
        //         resource: item.name,
        //         action: "menu:own",
        //         attributes:  "* ",
        //         isActive: true,
        //       });

        // });

    }


    React.useEffect(() => {
        const bodyElement = document.body;

        bodyElement.classList.add('flex', 'items-center', 'justify-center', 'min-h-screen', 'py-16', 'lg:py-10', 'bg-slate-50', 'dark:bg-zink-800', 'dark:text-zink-100', 'font-public');

        return () => {
            bodyElement.classList.remove('flex', 'items-center', 'justify-center', 'min-h-screen', 'py-16', 'lg:py-10', 'bg-slate-50', 'dark:bg-zink-800', 'dark:text-zink-100', 'font-public');
        }
    }, []);

    return (
        <React.Fragment>
            <div className="relative">
                <AuthIcon />
                <form action="#!" className="mt-10" onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}>

                    <div className="mb-0 w-screen lg:mx-auto lg:w-[500px] card shadow-lg border-none shadow-slate-100 relative">
                        <div className="!px-10 !py-12 card-body">
                            <Link to="/">
                                {/* <img src={logoLight} alt="" className="hidden h-6 mx-auto dark:block" /> */}
                                <img src={logo} alt="" className="block h-12 mx-auto dark:hidden" />
                            </Link>

                            <div className="mt-8 text-center">
                                <h4 className="mb-1 text-custom-500 dark:text-custom-500">Welcome Back !</h4>
                            </div>


                            {error && <div className="px-4 py-3 mb-3 text-sm text-red-500 border border-red-200 rounded-md bg-red-50 dark:bg-red-400/20 dark:border-red-500/50" id="successAlert">
                                <b>Wrong credentials.</b>
                                <br />
                                Invalid username or password
                            </div>}
                            <div className="mb-3">
                                <label htmlFor="email" className={`inline-block mb-2 text-base font-medium ${validation.touched.email && validation.errors.email ? 'mt-1 text-sm text-red-500' : ''}`}>
                                    Phone / Email</label>
                                <input
                                    type="text"
                                    id="email"
                                    name="email"
                                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                    placeholder="Enter Phone / Email"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.email || ""}
                                />


                            </div>
                            <div className="mb-3">
                                <label htmlFor="password" className={`inline-block mb-2 text-base font-medium ${validation.touched.password && validation.errors.password ? 'mt-1 text-sm text-red-500' : ''}`}>
                                    Password</label>

                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                    placeholder="Enter password"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.password || ""}
                                />

                            </div>
                            <div>
                                <div className="flex items-center gap-2">
                                    <input id="checkboxDefault1" className="size-4 border rounded-sm appearance-none bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-custom-500 checked:border-custom-500 dark:checked:bg-custom-500 dark:checked:border-custom-500 checked:disabled:bg-custom-400 checked:disabled:border-custom-400" type="checkbox" value="" />
                                    <label htmlFor="checkboxDefault1" className="inline-block text-base font-medium align-middle cursor-pointer">Remember me</label>
                                </div>
                                {/* <div id="remember-error" className="hidden mt-1 text-sm text-red-500">Please check the "Remember me" before submitting the form.</div> */}
                            </div>
                            <div className="mt-10">
                                {!isLoading ?
                                    <button type="submit" className="w-full text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">Sign In</button>
                                    :
                                    <button type="button" disabled className="flex w-full text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                        <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" style={{ marginLeft: '35%' }} /> Authenticating...
                                    </button>
                                }
                            </div>

                            <div className="mt-10 text-center">
                                <p className="mb-0 text-slate-500 dark:text-zink-200">Forgot password ? <Link to="/auth-reset-password-basic" className="font-semibold underline transition-all duration-150 ease-linear text-slate-500 dark:text-zink-200 hover:text-custom-500 dark:hover:text-custom-500"> Click here</Link> </p>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </React.Fragment>
    );
}

export default withRouter(Login);
